<app-side-menu>
  <div class="b2b-dashboard-content">
    <app-b2b-portfolio-health></app-b2b-portfolio-health>
  </div>
</app-side-menu>
